var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutAndusTpcGroupMenlynLocationMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Menlyn Pretoria location marker") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 13,
    fill: "#FFFFFF",
    fillOpacity: 0.06,
    stroke: "#FFFFFF",
    strokeOpacity: 0.17
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 39s10-9 10-19a10 10 0 1 0-20 0c0 10 10 19 10 19Z",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 20,
    r: 3.5,
    fill: "#30D6A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutAndusTpcGroupMenlynLocationMarker);
export default __webpack_public_path__ + "static/media/about-andus-tpc-group-menlyn-location-marker.a8a5dcca9f43eea0eba8b16b9f1dc1a0.svg";
export { ForwardRef as ReactComponent };